import '@ids/style-card';
import '@ids/style-logo';
import './Banner.css';
import './BannerVolvia.css';

import { useState } from 'react';

import type { Action, Content } from '../../global-types/Content';
import useTracking from '../../hooks/useTracking';
import { renderContent } from '../../utils/renderContent';

type BannerProps = {
  content: Content;
  viewId: number | undefined;
  dispatchActionEvent: (action: Action) => void;
};

function Banner({ content, viewId, dispatchActionEvent }: BannerProps) {
  const trackVisibilityElement = useTracking(content, viewId ?? undefined);
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  const [disableButton, setDisableButton] = useState(false);
  if (view === undefined) return null;

  const theme = (view.viewTheme ?? '').toString().toLowerCase();

  const { texts, linkStyledActions, buttonStyledActions } = renderContent({
    view,
    trackVisibilityElement,
    actionsConfig: {
      dispatchActionEvent,
      skipFirstAction: false,
      disableButton,
      setDisableButton,
    },
  });

  return (
    <div className={`if card elevated banner ${theme}`}>
      <div className="if card-content flex">
        <div className="if text-container align-content-center">
          {view.viewElements.logo && <span className="if logo mb-12" aria-label="if logotype" role="img"></span>}
          {texts}
          {linkStyledActions}
          {buttonStyledActions.length > 0 && (
            <div className="if flex flex-center gap-16 buttons">{buttonStyledActions}</div>
          )}
        </div>
        {view.viewElements.media?.[0] && (
          <div className="if flex overflow-hidden min-w-0 image-container">
            <img
              src={view.viewElements.media[0].url}
              alt={view.viewElements.media[0].alt}
              className="if size-w-100p size-h-100p object-fit-cover"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Banner;
